// extracted by mini-css-extract-plugin
module.exports = {"main-container":"style_main-container__3MzCz"};